import { useParams } from 'react-router-dom';
import { LeftNav } from '../components/nav';
import { AgentJob } from '../components/agent';

export default function AgentDetailPage() {
  const { id } = useParams();

  return <LeftNav>{id && <AgentJob jobId={id} />}</LeftNav>;
}
// {id && <AgentJob jobId={id} />}
